import React, { useState } from "react";

export default function CustomerIntelligencePanel({
  activeContact = {},
  selectedPhone,
  subscriber,
  onClose,
  onSelectTemplateAndOpen,
}) {
  const [copiedPhone, setCopiedPhone] = useState(false);
  const [copiedAddr, setCopiedAddr] = useState(false);

  const handleCopyPhone = () => {
    if (!selectedPhone) return;
    navigator.clipboard.writeText(`+${selectedPhone}`);
    setCopiedPhone(true);
    setTimeout(() => setCopiedPhone(false), 2000);
  };

  const handleCopyAddress = (addr) => {
    if (!addr) return;
    navigator.clipboard.writeText(addr);
    setCopiedAddr(true);
    setTimeout(() => setCopiedAddr(false), 2000);
  };

  const initial = (activeContact.name || "U")[0]?.toUpperCase();
  const isSubscriber = !!subscriber;

  // Format delivery address if present
  const fullAddress = subscriber
    ? [
        subscriber.address,
        subscriber.city,
        subscriber.district,
        subscriber.state,
        subscriber.pincode ? `PIN: ${subscriber.pincode}` : "",
      ]
        .filter(Boolean)
        .join(", ")
    : "";

  return (
    <aside className="wa-drawer-container" aria-label="Contact Details">
      {/* Header */}
      <div className="wa-drawer-header">
        <button
          type="button"
          className="wa-btn-drawer-close"
          onClick={onClose}
          title="Close details"
        >
          <i className="bi bi-x-lg"></i>
        </button>
        <h6 className="wa-drawer-title">Contact Info</h6>
      </div>

      <div className="wa-drawer-body">
        {/* Profile Card */}
        <div className="wa-drawer-profile-card">
          <div className={`wa-drawer-avatar ${isSubscriber ? "is-subscriber" : ""}`}>
            {initial}
          </div>
          <h4 className="wa-drawer-name">{activeContact.name || `+${selectedPhone}`}</h4>

          <div className="wa-drawer-phone-row">
            <span>+{selectedPhone}</span>
            <button
              type="button"
              className="wa-btn-copy-sm"
              onClick={handleCopyPhone}
              title="Copy phone"
            >
              <i className={`bi ${copiedPhone ? "bi-check-lg text-success" : "bi-copy"}`}></i>
            </button>
          </div>

          <a
            href={`https://web.whatsapp.com/send?phone=${selectedPhone}`}
            target="_blank"
            rel="noreferrer"
            className="wa-btn-open-wa"
          >
            <i className="bi bi-whatsapp me-2"></i>
            <span>Open in WhatsApp Web</span>
            <i className="bi bi-box-arrow-up-right ms-auto"></i>
          </a>
        </div>

        {/* Subscription Intelligence Card */}
        {subscriber ? (
          <div className="wa-drawer-sub-section">
            <div className="wa-sub-status-header">
              <span className="wa-sub-status-tag">
                <i className="bi bi-patch-check-fill me-1"></i>
                VERIFIED SUBSCRIBER
              </span>
              <span className={`wa-badge-status ${subscriber.is_active ? "active" : "expired"}`}>
                {subscriber.is_active ? "Active" : "Expired"}
              </span>
            </div>

            <div className="wa-details-grid">
              <div className="wa-detail-item">
                <span className="lbl">Subscriber ID</span>
                <span className="val highlight">
                  {subscriber.receipt_number || `VS-${subscriber.id}`}
                </span>
              </div>

              <div className="wa-detail-item">
                <span className="lbl">Plan</span>
                <span className="val">{subscriber.package_name || "Annual Magazine"}</span>
              </div>

              {subscriber.user_email && (
                <div className="wa-detail-item">
                  <span className="lbl">Email</span>
                  <span className="val text-truncate" title={subscriber.user_email}>
                    {subscriber.user_email}
                  </span>
                </div>
              )}

              {subscriber.pod_number && (
                <div className="wa-detail-item">
                  <span className="lbl">Courier POD</span>
                  <span className="val font-monospace">{subscriber.pod_number}</span>
                </div>
              )}
            </div>

            {/* Postal Address with 1-Click Copy */}
            {fullAddress && (
              <div className="wa-address-card">
                <div className="wa-address-header">
                  <span className="lbl">
                    <i className="bi bi-geo-alt-fill me-1 text-danger"></i> Dispatch Address
                  </span>
                  <button
                    type="button"
                    className="wa-btn-copy-address"
                    onClick={() => handleCopyAddress(fullAddress)}
                    title="Copy full postal address"
                  >
                    <i className={`bi ${copiedAddr ? "bi-check-lg text-success" : "bi-copy"} me-1`}></i>
                    <span>{copiedAddr ? "Copied" : "Copy"}</span>
                  </button>
                </div>
                <div className="wa-address-text">{fullAddress}</div>
              </div>
            )}

            {/* Fast Actions */}
            <div className="wa-actions-group">
              <span className="wa-actions-title">Fast Actions</span>
              <button
                type="button"
                className="wa-btn-action"
                onClick={() => onSelectTemplateAndOpen("vaithikasri_expiry_reminder")}
              >
                <i className="bi bi-alarm me-2 text-warning"></i>
                <span>Send Expiry Reminder</span>
              </button>

              <button
                type="button"
                className="wa-btn-action"
                onClick={() => onSelectTemplateAndOpen("vaithikasri_renewal_success")}
              >
                <i className="bi bi-check-circle me-2 text-success"></i>
                <span>Send Renewal Confirmation</span>
              </button>

              <a
                href="/admin/subscribers"
                className="wa-btn-action"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-box-arrow-up-right me-2 text-primary"></i>
                <span>View Full Subscriber Record</span>
              </a>
            </div>
          </div>
        ) : (
          <div className="wa-drawer-guest-card">
            <div className="wa-guest-icon">
              <i className="bi bi-person-x"></i>
            </div>
            <h5>Unregistered Contact</h5>
            <p>
              This phone number is not linked to any active subscriber in the database.
            </p>
            <a
              href="/admin/subscribers"
              className="btn btn-sm btn-outline-success w-100 mt-2"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bi bi-plus-circle me-1"></i> Add / Link Subscriber
            </a>
          </div>
        )}
      </div>
    </aside>
  );
}
